export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const fetchWait = (delay) => {
  return new Promise((resolve) => setTimeout(resolve, delay));
};

export const fetchRetry = (url, delay, tries, fetchOptions = {}) => {
  function onError(err) {
    var triesLeft = tries - 1;
    if (!triesLeft) throw err;
    return fetchWait(delay).then(() =>
      fetchRetry(url, delay, triesLeft, fetchOptions)
    );
  }
  return fetch(url, fetchOptions).catch(onError);
};
